import React, { ReactElement } from 'react';

import { TextAlignment } from '@philips-emr/tws-constants';

import { DataTableCheckbox, DataTableColumn } from '.';

interface DataTableMultiSelectColumnProps {
  dataLength: number;
  name: string;
  onChange: () => void;
  rowsLength: number;
}

function DataTableMultiSelectColumn(props: DataTableMultiSelectColumnProps): ReactElement {
  const { dataLength = 0, name, onChange, rowsLength = -1 } = props;

  const isChecked = dataLength === rowsLength;
  const isIndeterminate = !isChecked && rowsLength >= 1;

  return (
    <DataTableColumn headerAlignment={TextAlignment.CENTER} sortable={false} width={72}>
      <DataTableCheckbox
        indeterminate={isIndeterminate}
        name={name}
        onChange={onChange}
        value={isChecked}
      />
    </DataTableColumn>
  );
}

export default DataTableMultiSelectColumn;
